import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksNo = () => {
    return <HowStartpageWorks languageCode="no" />
}

export default HowStartpageWorksNo
